import { createSelector } from "reselect";
import { buildKey } from "./utils";
import { selectors as routerSelectors } from "../router";
import { getRouteUpdateTime } from "../router/selectors";

export const getCounts = (state, q, opts = {}) => {
  return state.search.counts[buildKey(q)];
};

const flattenedCountSelectorFactory = () => {
  const selectors = {};

  return function getFlattenedCounts(state, q) {
    if (!selectors[q]) {
      selectors[q] = createSelector(
        state => state.search.counts[buildKey(q)],
        data => {
          if (data) {
            return Object.keys(data.pages).reduce((acc, k) => {
              return [...acc, ...data.pages[k].results];
            }, []);
          }
          return [];
        }
      );
    }
    return selectors[q](state);
  };
};

export const getFlattenedCounts = flattenedCountSelectorFactory();

export const isCountsLoading = (state, q, opts = {}) => {
  const data = state.search.counts[buildKey(q)];
  return data ? data.loading : false;
};

export const getCurrentSearchTermForIsbn = (state, isbn) => {
  const data = state.search.content[isbn];
  return data ? data.query || "" : "";
};

export const getLastSearchTimeForIsbn = (state, isbn) => {
  const data = state.search.content[isbn];
  return data ? data.successTime : 0;
};

export const getSearchBookContent = (state, isbn) => {
  const data = state.search.content[isbn];
  return data ? data.results || [] : [];
};

export const isSearchBookContentSearching = (state, isbn) => {
  const data = state.search.content[isbn];
  return data ? data.isSearching : false;
};

export const isFinishedSearchingBookContent = (state, isbn) => {
  const data = state.search.content[isbn];
  return data ? data.searchComplete : false;
};

export const getCurrentQuery = state =>
  routerSelectors.getQueryParam(state, "q") ||
  routerSelectors.getQueryParam(state, "search");

export const isSearchingMetadata = state => {
  return state.search.metadata.isSearching;
};
export const getMetadataResults = state => {
  return state.search.metadata.results || [];
};

/**
 * In general, we want to persist the last search term for each isbn
 * so that if you close the panel and re-open it, you see the last
 * info you searched for. However, when you hit the search page,
 * we should instead show the results for the requested search on
 * initial open, and then persist any future changes.
 *
 * This is computed here so that it can be part of the base panel
 * behavior rather than having to customize the behavior at every
 * possible entry point into the panel
 *
 * @param state
 * @param isbn
 * @return {*}
 */
export const getDefaultSearchTerm = (state, isbn) => {
  const pageQuery = getCurrentQuery(state);
  const pageTime = getRouteUpdateTime(state);
  const lastContentQuery = getCurrentSearchTermForIsbn(state, isbn);
  const contentTime = getLastSearchTimeForIsbn(state, isbn);

  if (pageQuery && pageTime > contentTime) {
    return pageQuery;
  }
  return lastContentQuery;
};
